import type * as Types from "../../../graphql/graphql-generated.types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetProfileQueryVariables = Types.Exact<{
  input: Types.GetProfileInput;
}>;

export type GetProfileQuery = {
  __typename?: "Query";
  getProfile: {
    __typename?: "Profile";
    userUuid: string;
    firstName: string | null;
    lastName: string | null;
  };
};

export type BasicProfileFragment = {
  __typename?: "Profile";
  userUuid: string;
  firstName: string | null;
  lastName: string | null;
};

export type GetAttendanceReportQueryVariables = Types.Exact<{
  input: Types.GetAttendanceReportInput;
}>;

export type GetAttendanceReportQuery = {
  __typename?: "Query";
  getAttendanceReport: Array<{
    __typename?: "AttendanceReport";
    status: Types.AttendanceStatus;
    calendarItem: {
      __typename?: "CalendarItem";
      uuid: string;
      title: string;
      startDatetime: string;
      endDatetime: string;
      calendarItemType: {
        __typename?: "CalendarItemType";
        uuid: string | null;
        name: string | null;
      } | null;
    } | null;
    subscription: {
      __typename?: "Subscription";
      subscriptionUuid: string;
      planObject: {
        __typename?: "SubscriptionPlanSimple";
        uuid: string;
        name: string;
      };
    } | null;
    registration: {
      __typename?: "Registration";
      uuid: string;
      checkinUuid: string | null;
      waitlistUntilTimestamp: number | null;
      registrationTimestamp: number | null;
      checkin: {
        __typename?: "Checkin";
        uuid: string | null;
        checkinTimestamp: number;
      } | null;
    } | null;
    checkin: {
      __typename?: "Checkin";
      uuid: string | null;
      checkinTimestamp: number;
    } | null;
  }>;
};

export type AttendanceReportFragment = {
  __typename?: "AttendanceReport";
  status: Types.AttendanceStatus;
  calendarItem: {
    __typename?: "CalendarItem";
    uuid: string;
    title: string;
    startDatetime: string;
    endDatetime: string;
    calendarItemType: {
      __typename?: "CalendarItemType";
      uuid: string | null;
      name: string | null;
    } | null;
  } | null;
  subscription: {
    __typename?: "Subscription";
    subscriptionUuid: string;
    planObject: {
      __typename?: "SubscriptionPlanSimple";
      uuid: string;
      name: string;
    };
  } | null;
  registration: {
    __typename?: "Registration";
    uuid: string;
    checkinUuid: string | null;
    waitlistUntilTimestamp: number | null;
    registrationTimestamp: number | null;
    checkin: {
      __typename?: "Checkin";
      uuid: string | null;
      checkinTimestamp: number;
    } | null;
  } | null;
  checkin: {
    __typename?: "Checkin";
    uuid: string | null;
    checkinTimestamp: number;
  } | null;
};

export type GetFilterSubscriptionsQueryVariables = Types.Exact<{
  getSubscriptionInput: Types.GetSubscriptionsInput;
}>;

export type GetFilterSubscriptionsQuery = {
  __typename?: "Query";
  getSubscriptions: {
    __typename?: "SubscriptionsPaginatedResponse";
    subscriptions: Array<{
      __typename?: "Subscription";
      subscriptionUuid: string;
      planObject: {
        __typename?: "SubscriptionPlanSimple";
        uuid: string;
        name: string;
      };
    }> | null;
  };
};

export type SubscriptionFilterOptionFragment = {
  __typename?: "Subscription";
  subscriptionUuid: string;
  planObject: {
    __typename?: "SubscriptionPlanSimple";
    uuid: string;
    name: string;
  };
};

export const BasicProfileFragmentDoc = gql`
  fragment BasicProfile on Profile {
    userUuid
    firstName
    lastName
  }
`;
export const AttendanceReportFragmentDoc = gql`
  fragment AttendanceReport on AttendanceReport {
    calendarItem {
      uuid
      title
      startDatetime
      endDatetime
      calendarItemType {
        uuid
        name
      }
    }
    subscription {
      subscriptionUuid
      planObject {
        uuid
        name
      }
    }
    registration {
      uuid
      checkinUuid
      waitlistUntilTimestamp
      registrationTimestamp
      checkin {
        uuid
        checkinTimestamp
      }
    }
    checkin {
      uuid
      checkinTimestamp
    }
    status
  }
`;
export const SubscriptionFilterOptionFragmentDoc = gql`
  fragment SubscriptionFilterOption on Subscription {
    subscriptionUuid
    planObject {
      uuid
      name
    }
  }
`;
export const GetProfileDocument = gql`
  query GetProfile($input: GetProfileInput!) {
    getProfile(getProfileInput: $input) {
      ...BasicProfile
    }
  }
  ${BasicProfileFragmentDoc}
`;

/**
 * __useGetProfileQuery__
 *
 * To run a query within a React component, call `useGetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProfileQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProfileQuery,
    GetProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProfileQuery, GetProfileQueryVariables>(
    GetProfileDocument,
    options,
  );
}
export function useGetProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProfileQuery,
    GetProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProfileQuery, GetProfileQueryVariables>(
    GetProfileDocument,
    options,
  );
}
export type GetProfileQueryHookResult = ReturnType<typeof useGetProfileQuery>;
export type GetProfileLazyQueryHookResult = ReturnType<
  typeof useGetProfileLazyQuery
>;
export type GetProfileQueryResult = Apollo.QueryResult<
  GetProfileQuery,
  GetProfileQueryVariables
>;
export const GetAttendanceReportDocument = gql`
  query GetAttendanceReport($input: GetAttendanceReportInput!) {
    getAttendanceReport(getAttendanceReportInput: $input) {
      ...AttendanceReport
    }
  }
  ${AttendanceReportFragmentDoc}
`;

/**
 * __useGetAttendanceReportQuery__
 *
 * To run a query within a React component, call `useGetAttendanceReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendanceReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendanceReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAttendanceReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAttendanceReportQuery,
    GetAttendanceReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAttendanceReportQuery,
    GetAttendanceReportQueryVariables
  >(GetAttendanceReportDocument, options);
}
export function useGetAttendanceReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAttendanceReportQuery,
    GetAttendanceReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAttendanceReportQuery,
    GetAttendanceReportQueryVariables
  >(GetAttendanceReportDocument, options);
}
export type GetAttendanceReportQueryHookResult = ReturnType<
  typeof useGetAttendanceReportQuery
>;
export type GetAttendanceReportLazyQueryHookResult = ReturnType<
  typeof useGetAttendanceReportLazyQuery
>;
export type GetAttendanceReportQueryResult = Apollo.QueryResult<
  GetAttendanceReportQuery,
  GetAttendanceReportQueryVariables
>;
export const GetFilterSubscriptionsDocument = gql`
  query GetFilterSubscriptions($getSubscriptionInput: GetSubscriptionsInput!) {
    getSubscriptions(getSubscriptionInput: $getSubscriptionInput) {
      subscriptions {
        ...SubscriptionFilterOption
      }
    }
  }
  ${SubscriptionFilterOptionFragmentDoc}
`;

/**
 * __useGetFilterSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetFilterSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterSubscriptionsQuery({
 *   variables: {
 *      getSubscriptionInput: // value for 'getSubscriptionInput'
 *   },
 * });
 */
export function useGetFilterSubscriptionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFilterSubscriptionsQuery,
    GetFilterSubscriptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFilterSubscriptionsQuery,
    GetFilterSubscriptionsQueryVariables
  >(GetFilterSubscriptionsDocument, options);
}
export function useGetFilterSubscriptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFilterSubscriptionsQuery,
    GetFilterSubscriptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFilterSubscriptionsQuery,
    GetFilterSubscriptionsQueryVariables
  >(GetFilterSubscriptionsDocument, options);
}
export type GetFilterSubscriptionsQueryHookResult = ReturnType<
  typeof useGetFilterSubscriptionsQuery
>;
export type GetFilterSubscriptionsLazyQueryHookResult = ReturnType<
  typeof useGetFilterSubscriptionsLazyQuery
>;
export type GetFilterSubscriptionsQueryResult = Apollo.QueryResult<
  GetFilterSubscriptionsQuery,
  GetFilterSubscriptionsQueryVariables
>;
